export const isWebView = () => {
  var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test(userAgent),
    ios = /iphone|ipod|ipad/.test(userAgent);
  if (ios) {
    if (!standalone && safari) {
      // Safari
    } else if (!standalone && !safari) {
      // iOS webview
      return true;
    }
  } else {
    if (userAgent.includes("wv")) {
      // Android webview
      return true;
    } else {
      // Chrome
    }
  }
  return false;
};

export const getSlug = (pathName) => {
  let slug;
  if (pathName) {
    slug = pathName.split("/")[pathName.split("/").length - 1];
  } else {
    slug = "";
  }
  return slug;
};

export const SCREEN_WIDTH = window.innerWidth;
export const SCREEN_HEIGHT = window.innerHeight;

export const isMobileDevice = () => {
  return SCREEN_WIDTH <= 768;
};

export const isTabletDevice = () => {
  return SCREEN_WIDTH > 768 && SCREEN_WIDTH < 1024;
};

export const isDesktopDevice = () => {
  return SCREEN_WIDTH >= 1024;
};

export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileP: "390px",
  mobileX: "414px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopM: "1280px",
  laptopL: "1440px",
  laptopX: "1520px",
  desktop: "2560px",
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileP: `(min-width: ${size.mobileP})`,
  mobileX: `(min-width: ${size.mobileX})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopX: `(min-width: ${size.laptopX})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

export const isV4Template = () => {
  const appConfig = JSON.parse(localStorage.getItem("appConfig") || "{}");
  return appConfig?.TEMPLATE_ID === "TemplateFour";
};

export const checkMarketingPage = (slug) => {
  if (
    slug === "/bial-marketing-1" ||
    slug === "/bial-marketing-2" ||
    slug === "/bial-marketing-3" ||
    slug === "/bial-marketing-4" ||
    slug === "/bial-marketing-5"
  ) {
    return true;
  } else {
    return false;
  }
};


